import { useStore } from '@stores';
import { Utils } from '@utils';
import { RcFile } from 'antd/lib/upload';
import { useCallback, useState } from 'react';

export const useServiceOrderDocumentUpload = (serviceOrderId: string) => {
  const { orderStore } = useStore();
  const [uploading, setUploading] = useState(false);

  const handleUpload = useCallback(
    async (file: RcFile) => {
      setUploading(true);
      const type = Utils.getFileType(file);
      Utils.getBase64(file, async (base64) => {
        await orderStore
          .createDocument({
            type,
            name: file.name,
            contentType: file.type,
            content: base64,
            serviceOrderId,
          })
          .then(() => {
            setUploading(false);
          });
      });
    },
    [orderStore, serviceOrderId]
  );

  return { uploading, handleUpload };
};
